// views/DropsView.vue
<template>
  <!-- <div class="drops-container">
    <nav-bar />
    <div class="main-container">
      <side-menu :menu-items="menuItems" />
      <div class="content">
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </div>
    </div>
  </div> -->
  <div class="drops-container">
    <nav-bar @toggle-menu="toggleMobileMenu" />
    <div class="main-container">
      <side-menu 
        :menu-items="menuItems" 
        :class="{ 'active': isMobileMenuOpen }" 
      />
      <div class="content" @click="isMobileMenuOpen = false">
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import NavBar from '../components/NavBar.vue'
import SideMenu from '../components/SideMenu.vue'


const isMobileMenuOpen = ref(false)

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}


const menuItems = ref([
  {
    id: 1,
    icon: 'gift-box',
    alias_cn: 'Drops & Rewards',
    label: '掉宝与奖励',
    route: '/dashboard/home',
    // active: true
  },
  // {
  //   id: 2,
  //   icon: 'coins',
  //   label: 'Earn Points',
  //   route: '/drops/earn-points'
  // },
  // {
  //   id: 3,
  //   icon: 'history',
  //   label: 'Redemption History',
  //   route: '/drops/history'
  // },
  {
    id: 4,
    icon: 'gaming',
    label: 'Prime Gaming',
    route: '#',
    icon: 'prime',
    type: 'prime'
  },
  // {
  //   id: 5,
  //   icon: 'star',
  //   label: 'Gift Subscription',
  //   route: '#',
  //   type: 'subscription'
  // },  
  {
    id: 7,
    icon: 'cdkey-claim',
    label: 'Cdkey 兑换领取',
    route: '/dashboard/claimcdk',
    active: true,
    type: 'subscription'
  },
  {
    id: 8,
    icon: 'kick-reward',
    label: 'Kick 奖励',
    route: '/dashboard/kickrewards',
    type: 'subscription'
  },
  // {
  //   id: "auto-forward-task",
  //   icon: 'tool',
  //   label: 'Twitch自助挂宝',
  //   route: '/dashboard/autotask'
  // },
])
</script>

<style scoped>
.drops-container {
  min-height: 100vh;
  background-color: #1a1625;
  color: white;
}

.main-container {
  display: flex;
  padding-top: 60px; /* Height of navbar */
}

.content {
  flex: 1;
  padding: 20px;
  margin-left: 240px; /* Width of sidebar */
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .content {
    margin-left: 0;
    padding: 16px;
  }
  
  .main-container {
    position: relative;
  }
}
</style>
